import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import * as upcomingAppointmentList from '../../../redux/healthboard/requests/appointments-upcomming-req';
import * as historyAppointmentList from '../../../redux/healthboard/requests/appointments-history-req';
import {
  selectUpcomingAppointmentList,
  selectUpcomingCount,
  selectUpcomingAppointmentsPending,
  selectHistoryAppointmentsPending,
  selectHistoryAppointmentList,
  selectHistoryCount,
  selectUpcomingPaginationPending,
  selectHistoryPaginationPending,
} from '../../../redux/healthboard/selectors';

const mapStateToProps = state => ({
  upcomingList: selectUpcomingAppointmentList(state),
  upcomingCount: selectUpcomingCount(state),
  upcomingLoading: selectUpcomingAppointmentsPending(state),
  upcommingPaginationLoading: selectUpcomingPaginationPending(state),
  historyPaginationLoading: selectHistoryPaginationPending(state),
  historyLoading: selectHistoryAppointmentsPending(state),
  historyList: selectHistoryAppointmentList(state),
  historyCount: selectHistoryCount(state),
});
const mapDispatchToProps = {
  fetchUpcomingList: upcomingAppointmentList.actions.send,
  loadMoreUpcomingList: upcomingAppointmentList.actions.loadMore,
  fetchHistoryList: historyAppointmentList.actions.send,
  loadMoreHistoryList: historyAppointmentList.actions.loadMore,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({ userId, historyPaginationLoading, upcommingPaginationLoading }) => ({
      id: userId,
      paginationSending: upcommingPaginationLoading || historyPaginationLoading,
    }),
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/AppointmentListTabs/enhance.js